import { useLocation } from 'react-router-dom';

import { WORKLOAD_CATEGORIES } from '../_constants';
import type { WorkloadCategory, WorkloadView } from '../_constants';
import {
  getWorkloadsCategoryFromPathname,
  getWorkloadsViewFromPathname,
} from '../_utils';

type InventoryWorkloadsViewLocation = {
  view: WorkloadView;
  category: WorkloadCategory;
  search: string;
  pathname: string;
  to: (nextPathname: string) => { pathname: string; search: string };
};

export const useInventoryWorkloadsViewLocation =
  (): InventoryWorkloadsViewLocation => {
    const { pathname, search } = useLocation();

    const view = getWorkloadsViewFromPathname(pathname);
    const category =
      getWorkloadsCategoryFromPathname(pathname) ?? WORKLOAD_CATEGORIES.DEFAULT;

    return {
      view,
      category,
      search,
      pathname,
      to: (nextPathname) => ({ pathname: nextPathname, search }),
    };
  };
